/**
 * Declaración de accesibilidad (D-13, §5 del estándar).
 *
 * Se escribe aquí y no en un documento aparte porque tiene que ser
 * ALCANZABLE desde cualquier pantalla de la app, y porque lo que declara
 * —incluidas las excepciones— cambia en el mismo cambio que toca la
 * interfaz. Un documento que vive lejos se queda viejo.
 *
 * Las excepciones se dicen por su nombre y con fecha de compromiso. Una
 * declaración que solo dice «cumplimos» no es una declaración.
 */
export function Accesibilidad() {
  return (
    <section className="panel">
      <h1>Accesibilidad</h1>

      <p>
        Brújula se construye para cumplir las Pautas de Accesibilidad para el
        Contenido Web (WCAG) 2.2 en nivel AA. Esta pantalla dice en qué estado
        está esa promesa, qué falta y a quién avisarle.
      </p>

      <h2>Qué se evaluó</h2>
      <p>
        Última evaluación: 20 de octubre de 2026, sobre una copia de ensayo con
        datos desechables. Método: auditoría automatizada (contraste real,
        objetivos táctiles, etiquetas, foco, desborde a 320 px) en celular y
        escritorio, en tema claro y oscuro, más recorrido manual de teclado y
        zoom.
      </p>

      <h2>Lo que falta, con su motivo</h2>
      <ul>
        <li>
          <strong>Aviso de privacidad y términos.</strong> El sistema ya guarda
          avisos de privacidad versionados, pero esta app todavía no los
          muestra. No se enlaza a una página que no existe. Comprometido para
          la siguiente entrega de esta pantalla.
        </li>
        <li>
          <strong>Recorrido con lector de pantalla.</strong> Las etiquetas,
          regiones y mensajes de estado están puestos y verificados por código;
          falta el recorrido con un lector real, que es lo único que confirma
          el orden de lectura.
        </li>
        <li>
          <strong>Prueba con personas.</strong> Cinco personas, tres tareas
          reales. Todavía no se hace.
        </li>
      </ul>

      <h2>Decisiones que afectan lo que se ve</h2>
      <ul>
        <li>
          El mapa no usa cartografía de terceros: un fondo ajeno recibiría, una
          petición por tesela, qué secciones mira la campaña. A cambio el mapa
          se ve más austero, y los nombres de sección se dibujan como texto de
          la página —no dentro de la imagen— para que se puedan ampliar y
          leer con lector de pantalla.
        </li>
        <li>
          Ningún estado se comunica solo con color: lo que el mapa pinta de
          verde también lo dice la leyenda y el renglón que aparece al tocar
          una sección.
        </li>
      </ul>

      <h2>Reportar una barrera</h2>
      <p>
        Si algo de esta aplicación te impide trabajar, dilo a quien administra
        tu campaña. El compromiso es responder en diez días hábiles.
      </p>
    </section>
  );
}
